const THE_INSIGHTS_ROLES = ['THE_INSIGHTS', 'THE_INSIGHTS_WUR', 'THE_INSIGHTS_AUR'];

const theInsightsPermissions = (action, permissions, institutionId) => {
  if (
    action === 'the_insights:view_dashboard' &&
    institutionId in permissions &&
    THE_INSIGHTS_ROLES.some((role) => permissions[institutionId].includes(role))
  ) {
    return true;
  }

  return false;
};

module.exports = {
  theInsightsPermissions,
};